import axios from 'axios';
import React, { useEffect } from 'react';
import Tab from '../../../Components/Tab/Tab';
import { convertCost } from '../../../Utils/functions';
import './TargetSMS.scss';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

const routeList = {
    '/target-sms/visit': '방문일',
    '/target-sms/count' : '적립횟수',
    '/target-sms/retention' : '미방문',
    '/target-sms/price' : '구매금액',
    '/target-sms/point' : '포인트'
}

const TargetSMS = () => {
    const [ name, setName ] = React.useState('visit')
    const [ bell ,setBell ] = React.useState(0)//보유 벨

    const route = useSelector((state) => state.user.route) //현재 라우트 상태
    const navigate = useNavigate();

    useEffect(() => {
        getBell();
    },[])

    //보유 벨 get
    const getBell = () => {
        axios.get('/api/bell')
        .then((data) => {
            setBell(data.data.Total)
        })
    }
    
    const tabRoute = [
        { route : 'visit', header : '방문일' },
        { route : 'count', header : '적립횟수' },
        { route : 'retention', header : '미방문' },
        { route : 'price', header : '구매금액' },
        { route : 'point', header : '포인트' }
    ]

    return (
        <div className='target-sms'>
            <div className='header-row'>
                <p className='header-text'>문자 {'>'} 타겟문자 설정 {'>'}</p>
                <p className='header'>{routeList[route]}</p>
            </div>

            <div className='row' style={{ marginBottom : 24 }}>
                <div className='bell-box'>
                    보유벨 : {convertCost(bell)}개
                </div>
            </div>

            <Tab 
                routes={tabRoute}
                current={route.replace('/target-sms/','')}
                onTabChange={(name) => {setName(name);navigate(`/target-sms/${name}`)}}
                renderItems={{
                    'visit' : <Outlet />,
                    'count' : <Outlet />,
                    'retention' : <Outlet />,
                    'price' : <Outlet />,
                    'point' : <Outlet />
                }}
            />
        </div>
    )
}

export default TargetSMS;